export function hasOwnProp<T>(obj: T, prop: string) {
  return Object.prototype.hasOwnProperty.call(obj, prop)
}